import $ from '../vendor/jquery';
import Swiper from '../vendor/swiper';

$(function () {
  $('.gallery').each(function () {
    var gallery = $(this);
    var swiper = new Swiper (gallery.find('.gallery-slider').get(0), {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: gallery.find('.swiper-button-next'),
        prevEl: gallery.find('.swiper-button-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        500: {
          slidesPerView: 1,
        }
      },
      on: {
        init: renderControls
      }
    });

    swiper.on('resize', renderControls);

    function renderControls() {
      setTimeout(function () {
        if (this.params.slidesPerView >= this.slides.length) {
          $(this.navigation.nextEl).hide();
          $(this.navigation.prevEl).hide();
        } else {
          $(this.navigation.nextEl).show();
          $(this.navigation.prevEl).show();
        }
      }.bind(this), 0)
    }

    gallery.find('.gallery-link').magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      gallery: {
        enabled:true
      },
      overflowY: 'scroll',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  });
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/gallery.js